<ng-container *ngIf="acceptClassCodeParams$ | async as params">
  <div class="invite-container">
    <div class="invite-card">
      <h2 *ngIf="params?.role === _Roles.TEACHER; else student">Join as a Co-Teacher?</h2>
	<ng-template #student>
		<h2>Join as a Student?</h2>
	</ng-template>
      <p>
        You’ve been invited to join a classroom as a
		<ng-container *ngIf="params?.role === _Roles.TEACHER; else studentRole">co-teacher</ng-container>
		<ng-template #studentRole> student </ng-template>
        <strong>You're currently signed in as {{ params?.user_name }} ({{ params?.email }}) .</strong>
      </p>
      <div class="button-group">
        <button class="btn-add text-end" (click)="acceptInvite()">
          Accept
        </button>
      </div>
    </div>
  </div>
</ng-container>
